import styled from "@emotion/styled";
import React, { ReactNode } from "react";

const ButtonWrapper = ({ children }: { children: ReactNode }) => {
  return <StyleWrapper>{children}</StyleWrapper>;
};

export default ButtonWrapper;

const StyleWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  column-gap: 10px;
`;
